import React from "react";
import { BaseModal, IModalInstance } from "@whatslly/ui-components/modals";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import styles from "./ArchiveItemModal.module.scss";
import { useTranslation } from "react-i18next";

export const ArchiveItemModal: React.FC<IModalInstance<{ result: boolean }> & { name: string; type: "archive_chat" | "archive_contact" }> = ({
  closeModal,
  name,
  type,
}) => {
  const { t } = useTranslation();
  return (
    <BaseModal closeModal={closeModal} closeOnEscape={false} closeOnClickOutside={false}>
      <div data-testid={`${type}_modal`} className={styles.main}>
        <div className={styles.message}>{t(`whatsapp_business_api_agent_page.${type}.message1`, { name })}</div>
        <div className={styles.secondMessage}>{t(`whatsapp_business_api_agent_page.${type}.message2`)}</div>
      </div>

      <ModalButtons
        testId="modal-buttons-submit-button"
        submitText={t(`whatsapp_business_api_agent_page.${type}.archive`)}
        onCancel={() => closeModal({ result: false })}
        onSubmit={() => closeModal({ result: true })}
      />
    </BaseModal>
  );
};
